import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import AnimeCard from '@/components/base/AnimeCard';
import { animeList, categories } from '@/mocks/anime';

export default function CategoryPage() {
  const { type = 'rexue' } = useParams<{ type: string }>();
  const currentCategory = categories.find((c) => c.key === type) || categories[0];

  const filteredAnime = animeList.filter((a) => a.category === type);

  const categoryMap: Record<string, string> = {
    rexue: '热血',
    lianai: '恋爱',
    qihuan: '奇幻',
    gaoxiao: '搞笑',
    xuanyi: '悬疑',
    richang: '日常',
    zhandou: '战斗',
    kehuan: '科幻',
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: `${categoryMap[type] || '分类'}动漫 - 91动漫在线观看`,
            description: `91动漫${categoryMap[type] || ''}分类页面，汇聚海量正版高清${categoryMap[type] || ''}动漫资源。每日更新最新番剧，畅享在线观看。`,
            url: `https://www.91anime.com/category/${type}`,
            isPartOf: {
              '@type': 'WebSite',
              name: '91动漫',
              url: 'https://www.91anime.com/',
            },
          }),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="bg-background-100 border-b border-background-200/70">
            <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-6">
              <Breadcrumb
                items={[
                  { label: '首页', path: '/' },
                  { label: '番剧分类' },
                  { label: currentCategory.label },
                ]}
              />
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-4 mb-2">
                {currentCategory.label}动漫
              </h1>
              <p className="text-sm text-foreground-500">
                共 {filteredAnime.length} 部番剧 · 正版高清在线观看
              </p>
            </div>
          </div>

          <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-4">
            <div className="flex items-center gap-2 overflow-x-auto pb-3 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.key}
                  to={`/category/${cat.key}`}
                  className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                    type === cat.key
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200/70 border border-background-200/70'
                  }`}
                >
                  <i className={`${cat.icon} text-sm`}></i>
                  {cat.label}
                </Link>
              ))}
            </div>
          </div>

          <div className="max-w-[1280px] mx-auto px-4 md:px-6 pb-20">
            {filteredAnime.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
                {filteredAnime.map((anime) => (
                  <AnimeCard key={anime.id} anime={anime} showCategory={false} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-200 flex items-center justify-center">
                  <i className="ri-emotion-sad-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">该分类暂无番剧，请浏览其他分类</p>
              </div>
            )}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}